import script from "./Saturation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Saturation.vue?vue&type=script&lang=ts&setup=true"

import "./Saturation.vue?vue&type=style&index=0&id=d230faf4&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d230faf4"]])

export default __exports__